<template>
  <div>
    <van-row :style="live" class="p-075">
      <div>
        <van-col :span="24" style="line-height:1.7rem">
          <span class="f-s-10 liveTitle">近期直播课</span>
          <span class="liveMore f-l-r f-s-6" @click="goLiveList">查看更多 ></span>
        </van-col>
        <Live :liveList="liveList" />
      </div>
    </van-row>
  </div>
</template>

<script>
import Live from '@/components/common/Live/live'
export default {
  props:{
    liveList:{
      type:Array,
      default:() => {
        return []
      }
    }
  },
  components:{Live},
  data() {
    return {
      live: {
        background:
          "url(" + require("@/assets/imgs/home/liveBg.png") + ") no-repeat",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
      },
    };
  },
  methods:{
    goLiveList() {
      this.$store.commit("Live/editGoLiveNum")
      this.$router.push("/liveList");
    },
  }
};
</script>

<style scoped lang="less">
.liveTitle {
  color: #292E35;
}
.liveMore {
  color: #657081;
}
</style>
